// Single source of truth for LEAD_GENERATOR_THREAD query options
export const LEAD_GENERATOR_THREAD_QUERY_OPTIONS = {
    networkMode: "offlineFirst",
    retryAfter: true,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: 60 * 60 * 1000, // 1 hour
} as const;
